import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';

interface IManageSubscriptionResponse {
    redirectUrl: string;
}

const manageSubscription = async () => {
    const response = await apiClient.put('subscriptions');

    return (await response.json()) as IManageSubscriptionResponse;
};

export const useManageSubscriptionMutation = (
    options: UseMutationOptions<IManageSubscriptionResponse, IRequestException>
) => {
    return useMutation(async () => await manageSubscription(), options);
};
